<div
  class="top-gap centered-container"
  fxLayout="column"
  fxLayoutAlign="start center"
>
  <mat-carousel
    fxFill
    timings="1000ms ease-in"
    [autoplay]="true"
    interval="5000"
    color="primary"
    maxWidth="auto"
    [slides]="slides.length"
    [loop]="true"
    [hideArrows]="false"
    [hideIndicators]="false"
    [useKeyboard]="true"
    orientation="ltr"
    *ngIf="slides$ | async as slides; else loading"
    proportion="50"
  >
    <mat-carousel-slide
      #matCarouselSlide
      *ngFor="let slide of slides"
      [image]="slide"
      overlayColor="#00000040"
      [hideOverlay]="false"
    ></mat-carousel-slide>
    {{ slides }}
  </mat-carousel>
</div>

<ng-template #loading>
  <app-loading-spinner
    class="results-spinner"
    [show]="true"
  ></app-loading-spinner
></ng-template>
